import { Box, Button, Paper, Stack } from "@mui/material";
import { MouseEventHandler } from "react";
import ActionPanel, { ActionPanelProps } from "./ActionPanel";
import SearchHeader, { ISearchForm } from "../SearchHeader/SearchHeader";
import { Edit2, Plus, RefreshCw, Trash } from "react-feather";

export interface ButtonActionProps {
    /**
     * dialogBase children, usually the included sub-components.
     */
    children?: React.ReactNode;
    /**
     * The component used to render the search action content of the ActionPanel.
     * @default null
     */
    searchAction?: JSX.Element;
    /**
     * The component used to render the button action content of the ActionPanel.
     * @default null
     */
    buttonAction?: JSX.Element;

    /**
     * mouse click event handler for the new button.  this function determines the action that
     * are performed when the new button is clicked.
     */
    clickNew?: MouseEventHandler<HTMLButtonElement> | undefined;

    /**
     * mouse click event handler for the view button.  this function determines the action that
     * are performed when the view button is clicked.
     */
    clickView?: MouseEventHandler<HTMLButtonElement> | undefined;

    /**
     * mouse click event handler for the Delete button.  this function determines the action that
     * are performed when the Delete button is clicked.
     */
    clickDelete?: MouseEventHandler<HTMLButtonElement> | undefined;

    /**
     * mouse click event handler for the Clear button.  this function determines the action that
     * are performed when the Clear button is clicked.
     */
    clickClear?: MouseEventHandler<HTMLButtonElement> | undefined;

    /**
     * mouse click event handler for the Search button.  this function determines the action that
     * are performed when the Search button is clicked.
     */
    clickSearch?: (data: ISearchForm) => Promise<void>;

    hiddenSearchParams?: { name: string; value: string | number | undefined }[];
    additionalSearchParams?: { name: string; value: string | number | undefined }[];
}

/**
 * Button action buttons
 * @returns JSX.Element
 */
export interface KPIActionButtonProps {
    clickNew?: MouseEventHandler<HTMLButtonElement> | undefined;
    clickView?: MouseEventHandler<HTMLButtonElement> | undefined;
    clickDelete?: MouseEventHandler<HTMLButtonElement> | undefined;
    clickMetric?: MouseEventHandler<HTMLButtonElement> | undefined;
}
export const ButtonAction = ({ clickNew, clickView, clickDelete, clickClear }: ButtonActionProps) => {
    return (
        <div style={{ width: "100%", paddingLeft: "15px" }}>
            <Stack
                direction={"row"}
                spacing={2}
                // display={{ xs: "none", sm: "none", md: "none", lg: "block" }}
            >
                {clickNew && (
                    <Button disableElevation onClick={clickNew} color="success" variant="contained" startIcon={<Plus size={20} />} style={{ textTransform: "capitalize" }}>
                        {" "}
                        New{" "}
                    </Button>
                )}
                {clickView && (
                    <Button disableElevation onClick={clickView} variant="contained" color="primary" startIcon={<Edit2 size={20} />} style={{ textTransform: "capitalize" }}>
                        View
                    </Button>
                )}
                {clickDelete && (
                    <Button disableElevation onClick={clickDelete} variant="contained" color="error" startIcon={<Trash size={20} />} style={{ textTransform: "capitalize" }}>
                        Delete
                    </Button>
                )}
                {clickClear && (
                    <Button disableElevation onClick={clickClear} variant="contained" startIcon={<RefreshCw size={20} />} style={{ textTransform: "capitalize", backgroundColor: "gray" }}>
                        Reset
                    </Button>
                )}
            </Stack>

            {/* <Stack  direction={"row"} spacing={2} display={{ md: 'block', lg: 'none' }}>
         <SplitButton />
       </Stack> */}
        </div>
    );
};
export const KPIButtonAction = ({ clickNew, clickView, clickDelete, clickMetric }: KPIActionButtonProps) => {
    return (
        <Paper variant="outlined" style={{ width: "100%" }}>
            <Box
                style={{
                    display: "flex",
                    flex: "1",
                    padding: "8px",
                    overflowX: "auto"
                }}
            >
                <Box
                    style={{
                        display: "flex",
                        flex: "1",
                        alignItems: "center",
                        justifyContent: "space-between",
                        //minWidth: "1100px"
                        width: "100%"
                    }}
                >
                    <div style={{ width: "100%" }}>
                        <Stack
                            direction={"row"}
                            spacing={2}
                            // display={{ xs: "none", sm: "none", md: "none", lg: "block" }}
                        >
                            <Button disableElevation onClick={clickNew} color="success" variant="contained" startIcon={<Plus size={20} />} style={{ textTransform: "capitalize", marginRight: "5px" }}>
                                {" "}
                                New{" "}
                            </Button>
                            <Button disableElevation onClick={clickView} variant="contained" color="primary" startIcon={<Edit2 size={20} />} style={{ textTransform: "capitalize", marginLeft: "5px" }}>
                                View
                            </Button>
                            <Button disableElevation onClick={clickDelete} variant="contained" color="error" startIcon={<Trash size={20} />} style={{ textTransform: "capitalize", marginLeft: "5px" }}>
                                Delete
                            </Button>
                            <Button
                                disableElevation
                                onClick={clickMetric}
                                variant="contained"
                                startIcon={<RefreshCw size={20} />}
                                style={{ textTransform: "capitalize", backgroundColor: "gray", marginLeft: "5px" }}
                            >
                                Metrics
                            </Button>
                        </Stack>
                    </div>
                </Box>
            </Box>
        </Paper>
    );
};
export const ButtonActionPanel = ({ clickNew, clickView, clickDelete, clickClear, children }: any) => {
    return (
        <Paper variant="outlined" style={{ width: "100%" }}>
            <Box
                style={{
                    display: "flex",
                    flex: "1",
                    padding: "8px",
                    overflowX: "auto"
                }}
            >
                <Box
                    style={{
                        display: "flex",
                        flex: "1",
                        alignItems: "center",
                        justifyContent: "space-between",
                        //minWidth: "1100px"
                        width: "100%"
                    }}
                >
                    <Box> {<ButtonAction clickNew={clickNew} clickView={clickView} clickDelete={clickDelete} clickClear={clickClear} /> ?? null} </Box>
                    <Box> {children ?? null}</Box>
                </Box>
            </Box>
        </Paper>
    );
};
/**
 * Search action buttons
 * @returns JSX.Element
 */
const SearchAction = ({ clickSearch, hiddenSearchParams, additionalSearchParams }: ButtonActionProps) => {
    return (
        <Stack direction={"row"}>
            <SearchHeader onSearch={clickSearch} hiddenSearchParams={hiddenSearchParams} additionalSearchParams={additionalSearchParams as any} />
        </Stack>
    );
};

/**
 * The defaulf view for action component
 * @param searchAction
 * @param buttonAction
 */
export default function SetupActionPanel({
    clickClear,
    clickNew,
    clickDelete,
    clickView,
    clickSearch,
    hideSearch = false,
    children,
    hiddenSearchParams,
    additionalSearchParams,
    hideButtons = false
}: ActionPanelProps) {
    return (
        <ActionPanel
            searchAction={<SearchAction clickSearch={clickSearch} hiddenSearchParams={hiddenSearchParams} additionalSearchParams={additionalSearchParams as any} />}
            buttonAction={hideButtons ? undefined : <ButtonAction clickNew={clickNew} clickView={clickView} clickDelete={clickDelete} clickClear={clickClear} />}
            hideSearch={hideSearch}
        >
            {children}
        </ActionPanel>
    );
}
